/**
 * Live articles for the Home page select and the mode-switch report (R-17, C-6, D-5): the published site index
 * (alias + title) joined with the drafts (article id), so a draft or a retired article is never offered (the server
 * refuses any alias that is not live) and pending switch ids map to a title. Firebase only through firebase-core.
 * A tiny seam so the hook is unit-testable without Firebase.
 */
import { ArticleDraftService, type LiveArticle } from '@modules/firebase-core';

let service: ArticleDraftService | null = null;

export async function loadLiveArticles(projectId: string): Promise<LiveArticle[]> {
  service ??= new ArticleDraftService();
  return service.listLiveArticles(projectId);
}
